/**
 * Utilities for managing ERP section navigation state in localStorage
 */

const LAST_ERP_VIEW_KEY = "last-erp-view";

export type ErpViewType = "products-services" | "catalog";

export function saveLastErpView(view: ErpViewType): void {
  try {
    localStorage.setItem(LAST_ERP_VIEW_KEY, view);
  } catch (error) {
    console.warn("Failed to save last ERP view:", error);
  }
}

export function getLastErpView(): ErpViewType {
  try {
    const saved = localStorage.getItem(LAST_ERP_VIEW_KEY);
    // Support both old and new values for backward compatibility
    if (saved === "products-services" || saved === "catalog") {
      return saved;
    }
    // Migrate old "stock" value to "products-services"
    if (saved === "stock") {
      return "products-services";
    }
  } catch (error) {
    console.warn("Failed to read last ERP view:", error);
  }
  return "products-services";
}
